<template>
  <div class="modal fade modal-noborder modal-readFile" tabindex="-1" role="dialog" v-bind:id="'Modal_readFile_' + file.id">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-close-white"></i></button>
        </div>
        <div class="modal-body">
          <div class="file-wrapper">
            <div class="white-box">
              <div class="file-detail">
                <!--<iframe :src="'/pdf/web/viewer.html?file=' + file.url">预览</iframe>-->
              </div>
            </div>
            <p class="fs18 text-center white">{{ file.fileName }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <router-link class="btn btn-opt" data-dismiss="modal" :to="'/web/print-setting/' + file.id">开始打印</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalReadfile",
    props: ['file'],
    data: function () {
      return {
      }
    },
    methods: {

    },
    created: function () {
      console.info('readfile-init');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ModalReadfile.vue